import { Box } from '@factorialco/deprecated-design-system'
import { Icon, IconType } from '@factorialco/factorial-one-react'
import { IconAvatar, Select } from '@factorialco/factorial-one-react/dist/experimental'
import { ChevronDown } from '@factorialco/factorial-one-react/icons/app'

interface MediaDeviceSelectProps {
  onChange: (value: string) => void
  options: { label: string; value: string }[]
  placeholder: string
  searchBoxPlaceholder: string
  searchEmptyMessage: string
  enabled: boolean
  value: string
  icon?: IconType
}

export const MediaDeviceSelect = ({
  onChange,
  options,
  placeholder,
  searchBoxPlaceholder,
  searchEmptyMessage,
  enabled,
  value,
  icon,
}: MediaDeviceSelectProps) => {
  return (
    <Select
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      searchBoxPlaceholder={searchBoxPlaceholder}
      searchEmptyMessage={searchEmptyMessage}
      showSearchBox
      disabled={!enabled}
      value={value}
    >
      <Box
        background={!enabled ? 'grey200' : 'grey000White'}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey300',
          },
        }}
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        gap="s8"
        paddingX="s8"
        paddingY="s6"
        style={{
          cursor: !enabled ? 'default' : 'pointer',
          width: '100%',
          overflow: 'hidden',
          borderRadius: '0.75rem',
          transition: 'background-color 0.2s',
        }}
      >
        {icon && <Icon icon={icon} />}
        <p
          style={{
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          {value ? options.find((option) => option.value === value)?.label || value : placeholder}
        </p>
        <IconAvatar icon={ChevronDown} size="sm" className="hover:bg-f1-background-hover" />
      </Box>
    </Select>
  )
}
